import { Panel, PanelType } from "@fluentui/react";
import React from "react";
import DomainDataGrid from "./DomainDataGrid";

const DomainPanel = (props: { isOpen: boolean; onDismiss: (open: boolean) => void; tenantName?: string }) => {
  return (
    <Panel isOpen={props.isOpen} onDismiss={() => props.onDismiss(false)} type={PanelType.large} isLightDismiss>
      <DomainDataGrid tenantName={props.tenantName} />
    </Panel>
  );
};

export default DomainPanel;
